export interface Wizard {
  id: string
  wizardId: number
  title: string
  status: WizardStatus
  steps: WizardStep[]
}

export interface WizardStep {
  id: string
  name: string
  priority: number
  status: StepStatus
  children: WizardStep[]
}

export enum StepStatus {
  Active = 0,
  Complete = 1,
  Disabled = 2,
}

export enum WizardStatus {
  NotStarted = 0,
  InProgress = 1,
  Completed = 2,
}
